import styled from "styled-components";

export const ModalRespondToRescheduleRequestContents = styled.div`
	padding: 0 1em;
`;
